import {StyleSheet, View, Text} from 'react-native';
import {colors} from 'config/styles';
import {theme} from 'config/themes';

import type {StyleProp, ViewStyle, TextStyle, GestureResponderEvent} from 'react-native';

interface ProgressBarProps {
  items: ProgressItem[],
  texts?: ProgressText[],
  style?: StyleProp<ViewStyle>,
}

type ProgressItem = {
  value: number,
  color: string,
}

type ProgressText = {
  value: string,
  style?: StyleProp<TextStyle>,
  onPress?: ((event: GestureResponderEvent) => void) | undefined;
}

export function ProgressBar(props: ProgressBarProps) {
  return (
    <View style={[styles.root, props.style]}>
      <View style={styles.progress}>
        {props.items.filter(Boolean).map((item, i) =>
          <View
            key={i}
            accessibilityRole="progressbar"
            accessibilityValue={{now: !isNaN(item.value) ? item.value : 0}}
            style={[styles.bar, {
              width: !isNaN(item.value) ? `${item.value}%` : '0%',
              backgroundColor: item.color,
            }]}
          />
        )}
      </View>
      {props.texts?.length &&
        <View style={styles.details}>
          {props.texts.filter(Boolean).map((text, i) =>
            <Text
              key={i}
              style={[styles.text, text.style]}
              onPress={text.onPress}>
              {text.value}
            </Text>
          )}
        </View> 
      }
    </View>
  );
}

export const styles = StyleSheet.create({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  progress: {
    height: 6,
    borderRadius: 3,
    position: 'relative',
    backgroundColor: theme.transfers.progress.bar,
  },
  bar: {
    position: 'absolute',
    borderRadius: 3,
    bottom: 0,
    left: 0,
    top: 0,
  },
  details: {
    flex: 0,
    marginTop: 6,
    flexDirection: 'row',
  },
  text: {
    fontSize: 12,
    color: colors.neutral.mid,
  },
});
